<template>
  <div>
    <div class="w-20 border-t-4 border-n3yellow my-10"></div>
    <div class="page-heading">ALLGEMEINE GESCHÄFTSBEDINGUNGEN</div>

    <div class="space-y-8 page-content">
      <p><strong>1. GELTUNGSBEREICH UND VERTRAGSBEZIEHUNGEN</strong></p>
      <p>
        1.1. Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB“) gelten
        für die Vermittlung von Eintrittskarten durch die Firma N3 GmbH
        (nachfolgend „N3“, „N3 GmbH“ oder „wir“) zu kulturellen, sportlichen
        oder sonstigen Freizeitveranstaltungen unterschiedlicher Veranstalter an
        Kunden in Form von elektronischen Tickets (nachfolgend „Online-Tickets“)
        im Internet über die Webseite www.n3.app Für den Fall, dass der Kunde
        eigene, anders lautende AGB verwendet, werden diese nicht
        Vertragsbestandteil, sofern wir ihnen nicht schriftlich zugestimmt
        haben. Diese AGB umfassen sämtliche Lieferungen und Leistungen im
        Zusammenhang mit der Vermittlung des Erwerbs und der Lieferung der
        Online-Tickets sowie etwaige Leistungsstörungen im Verhältnis von N3 zum
        Kunden.
      </p>
      <p>
        1.2. Wir verkaufen die Online-Tickets lediglich als Vermittler im Namen
        und auf Rechnung des jeweiligen Veranstalters. Bezüglich der gebuchten
        Veranstaltung selbst kommt ausschließlich ein Vertrag zwischen Ihnen als
        Kunden und dem jeweiligen Veranstalter zustande. Dafür gelten
        möglicherweise Allgemeine Geschäftsbedingungen des Veranstalters. Diese
        treten neben diese AGB. Wer der jeweilige Veranstalter ist, wird Ihnen
        während des Bestellvorgangs angezeigt. Daraus folgt, dass von Ihnen als
        Kunden sämtliche Ansprüche bezüglich der Veranstaltung, deren Gestaltung
        oder im Zusammenhang mit dem Veranstaltungsbesuch ausschließlich
        gegenüber dem Veranstalter geltend zu machen sind. Dies bezieht sich
        insbesondere auf Ansprüche im Zusammenhang mit dem Ausfall oder der
        Verlegung einer Veranstaltung oder Programmänderungen.
      </p>
      <p>
        1.3. Bei diesen von uns vermittelten Verträgen über
        Freizeitveranstaltungen besteht kein Widerrufsrecht. Sie können Ihre
        Willenserklärung bzgl. der Bestellung von Tickets für
        Freizeitveranstaltungen daher nicht widerrufen.
      </p>
      <p>
        1.4. Sie als unser Kunde bestätigen vor jeder Bestellung von
        Online-Tickets auf den jeweiligen Shopseiten der einzelnen Veranstalter,
        dass Sie diese AGB zur Kenntnis genommen haben und sie als bindend
        akzeptieren. Die AGB sind im jeweils aktuellen Stand zu jedem Zeitpunkt
        auf der Webseite www.n3.app/terms abrufbar.
      </p>
      <p><strong>2. KAUF UND VERTRAGSABSCHLUSS</strong></p>
      <p>
        2.1. Für den Erwerb von Online-Tickets über N3 ist es lediglich
        erforderlich, dass Sie vor Abschluss Ihrer Bestellung wahrheitsgemäß
        Ihren Namen, Ihre Telefonnummer und Ihre E-Mail-Adresse angeben. Ihr
        Online-Ticket erhalten Sie nach Zahlung als QR-Code in einer E-Mail.
        Bitte bewahren Sie diese E-Mail sorgfältig auf.
      </p>
      <p>
        2.2. Der Vertrag über den Erwerb des Online-Tickets wird ausschließlich
        zwischen Ihnen und dem jeweiligen Veranstalter geschlossen. Soweit über
        N3 Veranstaltungen beworben und der Verkauf von Karten für die
        Veranstaltungen in Aussicht gestellt wird, stellt dies rechtlich
        lediglich eine unverbindliche Aufforderung an Sie dar, ein Kaufangebot
        abzugeben (sog. „invitatio ad offerendum“). Wir garantieren damit nicht,
        dass für die Veranstaltung noch Karten erhältlich sind. Das Angebot für
        einen Vertragsschluss geht von Ihnen aus, sobald Sie eine Bestellung
        abschließen. Die Annahme Ihres Angebots erfolgt durch uns für den
        jeweiligen Veranstalter unverzüglich nach Abschluss des Bestellvorgangs
        per E-Mail. Sollte, aus welchen Gründen auch immer, die von Ihnen
        gewünschte Anzahl von Online-Tickets nicht verfügbar sein, werden Sie
        hierüber noch vor Abschluss des Vertrages benachrichtigt und Sie sind an
        Ihr Angebot nicht mehr gebunden. Wir behalten uns darüber hinaus das
        Recht vor, Ihr Angebot ohne Angabe von Gründen abzulehnen.
      </p>
      <p>
        <strong
          >3. ZURVERFÜGUNGSTELLUNG DER ONLINE-TICKETS UND GÜLTIGKEIT</strong
        >
      </p>
      <p>
        3.1. Wir stellen Ihnen für jede Buchung ein Online-Ticket mit einem
        persönlichen Code (nachfolgend „Berechtigungscode“) zur Verfügung. Mit
        Verlassen der Veranstaltung bzw. einmaliger Freischaltung verliert das
        Online-Ticket seine Gültigkeit.
      </p>
      <p>
        3.2. Der E-Mail-Versand Ihres / Ihrer Online-Tickets erfolgt direkt mit
        Vertragsschluss, bei einer Zahlung per Vorkasse jedoch erst, wenn die
        Zahlung rechtzeitig eingegangen ist.
      </p>
      <p>
        3.3. Mit der Zurverfügungstellung Ihres/Ihrer Online-Tickets sind alle
        Pflichten unsererseits hinsichtlich des Online-Ticketerwerbs erfüllt.
        Die Versendung einer weiteren Eintrittskarte per Post und/oder Fax
        und/oder auf sonstige Weise erfolgt nicht. Hierauf wird ausdrücklich
        hingewiesen.
      </p>
      <p>
        3.4. Sie sind allein für die Sicherung Ihres Online-Tickets und
        insbesondere des auf dem Ticket enthaltenen Berechtigungscodes
        verantwortlich. Sie können sich gegenüber N3 oder dem Veranstalter nicht
        darauf berufen, dass sich eine andere Person unter Vorlage Ihres
        Online-Tickets Zugang zur Veranstaltung verschafft habe. Bitte sorgen
        Sie deshalb dafür, dass von Ihrem Online-Ticket immer nur ein Ausdruck
        bzw. Exemplar existiert, insbesondere dann, wenn dieses nachgedruckt
        oder von Ihnen per E-Mail weiter versandt wurde. Andernfalls besteht die
        Gefahr, dass eine andere Person sich mit dem nun zusätzlich vorhandenen
        Online-Ticket Zugang zur Veranstaltung verschafft und dadurch den nur
        einmalig verwertbaren Berechtigungscode entwertet, wodurch Ihnen dann
        der Besuch der Veranstaltung nicht mehr möglich ist. Außerdem sollten
        Sie Ihr Online-Ticket so sorgfältig wie Bargeld aufbewahren, so dass
        keine unbefugte Person hiervon eine Kopie machen oder anderweitigen
        Missbrauch betreiben kann.
      </p>
      <p>
        3.5. Eine Mehrfachnutzung Ihres Online-Tickets ist ausdrücklich
        untersagt.
      </p>
      <p><strong>4. FEHLER BEI DER ONLINE-TICKETBESTELLUNG</strong></p>
      <p>
        4.1. Für alle im Bestelldialog von Ihnen benannten Daten tragen Sie das
        alleinige Risiko. Etwaige Bestellfehler, insbesondere wenn von Ihnen
        versehentlich ein anderes als das gewünschte Datum oder eine andere als
        die gewünschte Veranstaltung eingegeben wird, gehen zu Ihren Lasten
        unter Berücksichtigung der gesetzlichen Korrekturmöglichkeiten.
      </p>
      <p>
        4.2. Sie sind verpflichtet, Ihr Online-Ticket umgehend nachdem Sie es
        erhalten haben, darauf zu überprüfen, ob es mit Ihrer Bestellung
        übereinstimmt und uns etwaige Abweichungen per E-Mail mitzuteilen. Sie
        werden von uns dann ein anderes Online-Ticket erhalten. Sofern wir das
        Online-Ticket fehlerhaft ausgestellt haben und zum Zeitpunkt Ihrer
        Mitteilung keine Online-Tickets mehr vermittelt werden können, etwa weil
        die Veranstaltung ausverkauft ist, erstatten wir Ihnen an uns geleistete
        Zahlungen selbstverständlich zurück. Schadensersatzansprüche des Kunden
        bleiben unberührt.
      </p>
      <p><strong>5. FÄLLIGKEIT UND ZAHLUNG</strong></p>
      <p>
        5.1. Sie können Ihr Online-Ticket je nach Veranstaltung per Kreditkarte
        und/oder per Vorkasse durch Überweisung und/oder per PayPal und/oder per
        Sofort Überweisung (Ziffer 5.2 bis 5.4) bezahlen. Der Ticketkaufpreis,
        der sich aus Ticketgrundpreis, Vorverkaufsgebühr, ÖPNV-Gebühren,
        sonstigen Gebühren jeweils inkl. gesetzlicher Mehrwertsteuer
        zusammensetzt (nachfolgend „Ticketkaufpreis“), ist nach Vertragsschluss
        sofort zur Zahlung fällig. Hiervon abweichend ist bei der Bezahlung per
        Vorkasse der Ticketkaufpreis bis zu dem in der Vertragsbestätigung
        mitgeteilten Datum vollständig auf das dort genannte Konto zu
        überweisen.
      </p>
      <p>
        5.2. Die Zahlung per Kreditkarte erfolgt über ein verschlüsseltes
        Online-Bezahlungssystem (SSL Secure Socket Layer) mit bis zu 128 Bit,
        abhängig von der Browserkonfiguration Ihres Rechners. Die Zahlung mit
        Kreditkarte setzt die Angabe des Kreditkarteninhabers, der
        Kreditkartennummer zzgl. eines etwaigen SicherheitsPINs und den
        jeweiligen Gültigkeitszeitraum der Kreditkarte auf dem hierfür
        vorgesehenen Eingabeformular voraus. Nicht zulässig ist der Einsatz von
        sog. virtuellen Kreditkarten bzw. Prepaid-Kreditkarten, bei denen
        Zahlungen nicht auf Kredit-, sondern auf Guthabenbasis abgewickelt
        werden und der zu bezahlende Betrag aus einem vorher bezahlten Guthaben
        beglichen wird. Im Fall eines Rückzugs des Ticketkaufpreises durch Ihre
        Bank haben wir das Recht, ohne weitere Ankündigung das Online-Ticket zu
        sperren. Danach ist Ihnen mit diesem Ticket ein Zutritt zur
        Veranstaltung nicht mehr möglich (auch nicht bei
        verspätetem/nachträglichem Zahlungseingang).
      </p>
      <p>
        5.3. Bei der Zahlung per Vorkasse werden die von Ihnen gebuchten
        Online-Tickets für Sie von unserem Ticketsystem fünf (5) Tage lang
        reserviert. Ihre Zahlung muss bis zu dem in der Vertragsbestätigung
        mitgeteilten Datum auf dem dort genannten Konto eingegangen sein (siehe
        Ziffer 5.1). Das Rechtsgeschäft steht und fällt mit der fristgerechten
        Bezahlung des Ticketkaufpreises durch Sie („relative Fixschuld“). Geht
        die Zahlung nicht rechtzeitig ein, werden die reservierten Tickets von
        unserem System automatisch im Interesse der anderen Fans wieder für den
        Verkauf freigegeben und dem Veranstalter sowie uns ist ein Festhalten am
        Vertrag mit Ihnen nicht mehr zumutbar. Müssten wir Ihnen vor dem
        Rücktritt zunächst eine angemessene Nachfrist zur Zahlung setzen, ginge
        dies zu Lasten der anderen Fans, würde zu einem erhöhten
        Verwaltungsaufwand führen und die Zahlungsart Vorkasse über Gebühr
        gegenüber den anderen Zahlungsarten bevorzugen. Der Veranstalter und wir
        behalten uns aus den genannten Gründen das Recht vor, sofort vom Vertrag
        zurückzutreten, ohne dass es einer Fristsetzung bedarf (§ 323 Abs. 2 Nr.
        2 BGB).
      </p>
      <p>
        5.4. Das Recht, das Online-Ticket zum Eintritt in die gebuchte
        Veranstaltung zu benutzen, behält sich der Veranstalter bis zur
        vollständigen Zahlung nach Ziffer 5.2 bzw. 5.3 vor.
      </p>
      <p>
        <strong
          >6. RÜCKGABE VON ONLINE-TICKETS / TICKETKAUFPREISERSTATTUNG IM FALL
          DES AUSFALLS ODER EINER VERLEGUNG DER VERANSTALTUNG</strong
        >
      </p>
      <p>
        6.1. Ein Anspruch auf Rückgabe von Online-Tickets und Erstattung des
        Ticketkaufpreises mit Ausnahme der Vorverkaufsgebühr besteht
        grundsätzlich nur bei Ausfall und/oder Verlegung von Veranstaltungen.
        Dieser Anspruch betrifft die Durchführung der Veranstaltung und richtet
        sich daher gegen den Veranstalter. N3 übernimmt in einem solchen Fall
        lediglich die Rückabwicklung im Rahmen des Vertragsverhältnisses
        zwischen Kunden und Veranstalter, soweit der Veranstalter N3 die
        entsprechenden Beträge zur Verfügung stellt. Zur Rückerstattung der an
        den Veranstalter geleisteten Vorverkaufsgebühr sind wir nicht
        verpflichtet.
      </p>
      <p>
        <strong
          >7. BESCHRÄNKUNGEN BEIM ERWERB UND DER WEITERGABE VON TICKETS</strong
        >
      </p>
      <p>
        7.1. Aus Gründen der Fairness, zur Unterbindung des Weiterverkaufs von
        Tickets zu überhöhten Preisen und um eine damit verbundene
        Rufbeeinträchtigung des Veranstalters zu vermeiden, liegt es im
        Interesse des Veranstalters, den Erwerb und die Weitergabe von Tickets
        einzuschränken. Sie verpflichten sich, das/die Online-Ticket(s)
        ausschließlich zum privaten Gebrauch zu erwerben und zu nutzen. Ihnen
        ist es insbesondere untersagt:
      </p>
      <p>
        a) Online-Tickets ohne vorherige ausdrückliche Zustimmung des jeweiligen
        Veranstalters weiterzugeben oder zu veräußern oder im Namen eines
        Dritten zu erwerben, wenn dies im Rahmen einer gewerblichen oder
        kommerziellen Tätigkeit erfolgt,<br />
        b) Online-Tickets im Rahmen von vom Veranstalter nicht autorisierten
        Internetauktionen zum Verkauf anzubieten,<br />
        c) Online-Tickets ohne vorherige ausdrückliche Zustimmung des jeweiligen
        Veranstalters an Dritte zu verkaufen, um Gewinn zu erzielen oder im
        Namen eines Dritten zu erwerben, um mit der Vermittlungstätigkeit für
        den Dritten Gewinn zu erzielen,<br />
        d) Online-Tickets zu Zwecken der Werbung, der Vermarktung, als Bonus,
        Werbegeschenk oder Gewinn oder Teil eines vom Veranstalter nicht
        autorisierten Hospitality- oder Reisepakets weiterzugeben und/oder zu
        veräußern,<br />
        e) Online-Tickets vor dem Veranstaltungsort zu verkaufen oder<br />
        f) Online-Tickets unter Einschaltung eines in Ihrem Namen auftretenden
        gewerblich oder kommerziell handelnden Dritten als Ihrem Stellvertreter
        zu erwerben, es sei denn, dass die an den Dritten hierfür zu zahlenden
        Gebühren insgesamt maximal 15% des Ticketkaufpreises (Ziffer 5.1)
        betragen.
      </p>
      <p>
        7.2. Für jeden Fall einer schuldhaften Zuwiderhandlung gegen die in
        Ziffer 7.1 enthaltenen Verbote kann der Veranstalter von Ihnen die
        Zahlung einer Vertragsstrafe verlangen, deren Höhe der Veranstalter nach
        billigem Ermessen festsetzen kann und die im Streitfall vom Gericht
        überprüft werden kann. Die Höhe der Vertragsstrafe richtet sich im
        Regelfall nach dem aktuellen Angebots- bzw. Weiterveräußerungspreis,
        mindestens jedoch nach dem Ticketkaufpreis (Ziffer 5.1) der entgegen
        Ziffer 7.1 angebotenen oder weitergegebenen Tickets. Die Vertragsstrafe
        beträgt insgesamt maximal EUR 7.500,00. Weitergehende
        Schadensersatzansprüche bzw. Vertragsstrafeforderungen wegen sonstiger
        Verstöße gegen diese AGB bleiben unberührt. Eine gezahlte Vertragsstrafe
        wird auf einen Schadensersatzanspruch angerechnet.
      </p>
      <p>
        7.3. N3 behält sich im Fall eines Verstoßes gegen Ziffer 7.1 vor, den
        Erwerber künftig vom Erwerb über N3 auszuschließen. Der Ausschluss
        erfolgt durch Sperrung des Kundenkontos.
      </p>
      <p>
        7.4. Im Falle eines Verstoßes gegen Ziffer 7.1 f) kommt der Vertrag über
        den Besuch der Veranstaltung nicht zustande, da die Stellvertretung in
        diesem Fall ausgeschlossen ist. Der bereits gezahlte Ticketkaufpreis
        (Ziffer 5.1) mit Ausnahme der Vorverkaufsgebühr wird Ihnen in diesem
        Falle zurückerstattet. Ein bereits ausgestelltes Ticket wird von uns
        gesperrt und verliert damit seine Gültigkeit.
      </p>
      <p>
        7.5. Sollte N3 Ihr Kundenkonto gemäß Ziffer 7.3 gesperrt haben, so ist
        es Ihnen künftig untersagt, sich erneut unter Ihrem oder einem anderen
        Namen über N3 zu registrieren. Für jeden Fall einer schuldhaften
        Zuwiderhandlung gegen dieses Verbot kann N3 von Ihnen die Zahlung einer
        Vertragsstrafe verlangen, deren Höhe N3 nach billigem Ermessen
        festsetzen kann und die im Streitfall vom Gericht überprüft werden kann.
        Die Vertragsstrafe beträgt insgesamt maximal EUR 1.000,00. Weitergehende
        Schadensersatzansprüche bleiben unberührt. Eine gezahlte Vertragsstrafe
        wird auf einen Schadensersatzanspruch angerechnet.
      </p>
      <p>
        <strong
          >8. BESONDERE BESTIMMUNGEN FÜR DEN ERWERB PERSONALISIERTER
          TICKETS</strong
        >
      </p>
      <p>
        8.1. Für bestimmte Veranstaltungen sind die Online-Tickets
        personalisiert, d.h. nur derjenige hat das Recht, Zutritt zur
        Veranstaltung zu verlangen, der Inhaber des Besuchsrechts ist. Sein Name
        ist Bestandteil des Online-Tickets. Diese Veranstaltungen sind im
        Bestellvorgang mit einem entsprechenden Hinweis auf die Personalisierung
        der Online-Tickets gekennzeichnet. Sie verpflichten sich, das/die
        Online-Ticket(s) ausschließlich zum privaten Gebrauch zu erwerben und zu
        nutzen. Es gilt Ziffer 7.1. Der von Ihnen bei der Buchung angegebene
        Vor- und Nachname wird automatisch auf dem Online-Ticket vermerkt. Das
        Rechtsgeschäft steht und fällt mit der fristgerechten sofortigen und
        wahrheitsgemäßen Angabe der unterschiedlichen Namen der Ticketinhaber
        beim Kauf, da die Tickets sofort im Anschluss auf die im Kaufvorgang von
        Ihnen angegebenen Namen ausgestellt werden („relative Fixschuld“).
        Ferner bestätigen Sie, dass Sie berechtigt sind, im Namen von Dritten
        das Ticket bzw. die Tickets zu personalisieren. In diesen Fällen kommt
        der Vertrag ausschließlich zwischen Ihnen und dem Veranstalter zustande.
        Die von Ihnen benannten weiteren Personen werden durch diesen Vertrag
        lediglich begünstigt und erhalten ein eigenes Recht zum Besuch der
        Veranstaltung (§§ 328 ff. BGB).
      </p>
      <p>
        8.2. Eine Berechtigung zum Besuch der Veranstaltung besteht nur auf der
        Grundlage des Vertrags, den Sie mit dem Veranstalter geschlossen haben
        (Ziffer 2.1). Zudem muss Ihr Name auf dem Ticket vermerkt sein. Aufgrund
        des zwischen Ihnen und dem Veranstalter geschlossenen Vertrags sind
        Dritte, für die Sie ein personalisiertes Online-Ticket erworben haben,
        ebenfalls zum Besuch der Veranstaltung berechtigt. Der Name dieses
        Dritten muss auf seinem Ticket vermerkt sein. Eine Berechtigung zum
        Besuch der Veranstaltung besteht außerdem bei Personen, die nach Ziffer
        10.4 in den Vertrag mit dem Veranstalter eingetreten sind. Der Name
        dieser Person muss auf ihrem Ticket vermerkt sein. Voraussetzung für den
        Besuch der Veranstaltung ist ferner, dass Sie bzw. die Person, für die
        Sie Online-Tickets bestellt haben oder die nach Ziffer 10.4 in den
        Vertrag mit dem Veranstalter eingetreten ist, sich bei der
        Einlasskontrolle auf Verlangen mit Ihrem/seinem gültigen Pass,
        Personalausweis, Führerschein, Kreditkarte oder EC-Karte ausweisen kann.
      </p>
      <p>
        8.3. Der Veranstalter ist nicht verpflichtet, bei der Einlasskontrolle
        die Vorlage der genannten Dokumente zu verlangen, um so die Berechtigung
        des Ticketinhabers zu prüfen. Der Veranstalter wird auch dann seinem
        Vertragspartner gegenüber von seiner Leistungspflicht frei, wenn sich
        eine andere Person unter Vorlage des Online-Tickets Zugang zur
        Veranstaltung verschafft.
      </p>
      <p>
        8.4. Sie können Ihre Rechte und Pflichten aus dem Vertrag mit dem
        Veranstalter (und damit auch das Recht, Zutritt zur Veranstaltung zu
        verlangen) nur dadurch auf einen Dritten übertragen, dass der Dritte
        unter Übernahme sämtlicher Rechte und Pflichten an Ihrer Stelle in den
        Vertrag mit dem Veranstalter eintritt. Dieser Eintritt setzt die
        Zustimmung des Veranstalters voraus, die hiermit unter den in Ziffer 8.5
        genannten Einschränkungen vorab erteilt wird.
      </p>
      <p>
        8.5. Aus Gründen der Fairness, zur Unterbindung des Weiterverkaufs von
        Tickets zu überhöhten Preisen und um eine damit verbundene Rufschädigung
        des Veranstalters zu vermeiden, wird die Zustimmung des Veranstalters
        zum Eintritt eines Dritten in den Veranstaltervertrag gemäß Ziffer 8.4
        in den folgenden Fällen nicht erteilt:
      </p>
      <p>
        a) bei einer Weitergabe oder Veräußerung von Online-Tickets oder dem
        Erwerb von Online-Tickets für einen Dritten, wenn dies im Rahmen einer
        gewerblichen oder kommerziellen Tätigkeit erfolgt, ohne vorherige
        ausdrückliche Zustimmung des Veranstalters,<br />
        b) bei einer Veräußerung von Online-Tickets im Rahmen von vom
        Veranstalter nicht autorisierten Internetauktionen,<br />
        c) bei einer Veräußerung von Online-Tickets zu einem Preis, der den
        Ticketkaufpreis (Ziffer 5.1) zuzüglich Unkosten, die dem Verkäufer sonst
        aufgrund des Erwerbs oder der Weiterveräußerung des Tickets entstanden
        sind (maximal jedoch in Höhe von 15% des Ticketkaufpreises (Ziffer 5.1))
        übersteigt,<br />
        d) bei einer Veräußerung von Online-Tickets um Gewinn zu erzielen oder
        einem Erwerb der Online-Tickets im Namen eines Dritten, um mit der
        Vermittlungstätigkeit Gewinn zu erzielen,<br />
        e) bei einer Weitergabe und/oder Veräußerung von Online-Tickets zu
        Zwecken der Werbung oder Vermarktung, als Bonus, Werbegeschenk oder
        Gewinn oder als Teil eines vom Veranstalter nicht autorisierten
        Hospitality- oder Reisepakets, oder<br />
        f) bei einer Veräußerung von Online-Tickets ohne Hinweis auf diese AGB,
        insbesondere Ziffer 8.4 und diese Ziffer 8.5.
      </p>
      <p>
        In diesen Fällen ist sowohl das Angebot als auch eine Weitergabe
        und/oder Weiterveräußerung von Online-Tickets untersagt. Ein Verkauf von
        Online-Tickets vor dem Veranstaltungsort ist ausnahmslos untersagt.
      </p>
      <p>
        8.6. Für jeden Fall einer schuldhaften Zuwiderhandlung gegen die in
        Ziffer 8.5 enthaltenen Verbote, einschließlich des Verbots, in den in
        Ziffer 8.5 genannten Fällen Online-Tickets anzubieten, ist der
        Veranstalter darüber hinaus berechtigt, von Ihnen die Zahlung einer
        Vertragsstrafe zu verlangen. Die Höhe der Vertragsstrafe kann der
        Veranstalter nach billigem Ermessen festsetzen und sie kann im
        Streitfall von einem Gericht überprüft werden. Die Höhe der
        Vertragsstrafe richtet sich im Regelfall nach dem aktuellen Angebots-
        bzw. Weiterveräußerungspreis, mindestens jedoch nach dem Ticketkaufpreis
        (Ziffer 5.1) der entgegen Ziffer 10.5 angebotenen oder weitergegebenen
        Tickets. Die Vertragsstrafe beträgt insgesamt maximal EUR 7.500,00.
        Weitergehende Schadensersatzansprüche bzw. Vertragsstrafeforderungen
        wegen sonstiger Verstöße gegen diese AGB bleiben unberührt. Eine
        gezahlte Vertragsstrafe wird auf einen Schadensersatzanspruch
        angerechnet.
      </p>
      <p>
        <strong
          >9. ÜBERTRAGUNG UND UMPERSONALISIERUNG DER PERSONALISIERTEN
          ONLINE-TICKETS</strong
        >
      </p>
      <p>
        9.1. Vorbehaltlich der Ziffer 8.4 und 8.5, d.h. nur unter der
        Voraussetzung, dass der Dritte in den Vertrag mit dem Veranstalter unter
        Einschluss dieser AGB eintritt und der Veranstalter hierzu nach Ziffer
        8.4 seine Zustimmung erteilt hat, sind Sie berechtigt, ein von Ihnen
        erworbenes personalisiertes Online-Ticket, d.h. das Besuchsrecht, auf
        einen Dritten zu übertragen. Nach dieser Übertragung (§ 398 BGB) muss
        die Umpersonalisierung des Tickets auf den neuen Inhaber des
        Besuchsrechts erfolgen.
      </p>
      <p>
        9.2. Für den Fall, dass Sie Ihr Ticket auf anderem Wege auf einen
        Dritten übertragen wollen, z.B. durch Verschenken, muss nach Maßgabe des
        nachfolgend in Ziffer 9.3 ff. beschriebenen Verfahrens die
        Umpersonalisierung des Tickets durch uns erfolgen. Dazu müssen Ihnen der
        Name und die E-Mail-Adresse der Person, auf die Sie Ihr Online-Ticket
        übertragen wollen, bekannt sein.
      </p>
      <p>
        9.3. Für die Umpersonalisierung Ihres Online-Tickets müssen Sie sich
        support@n3.app melden. Weiter werden Sie aufgefordert, zur
        Identifizierung ein kopierfähiges amtliches Ausweisdokument (nicht den
        Personalausweis oder Pass), aus dem die Identität des Ticketinhabers
        hervor geht (z.B. Krankenversicherungskarte, Führerschein) an uns zu
        senden. Wir prüfen anhand Ihrer Daten, ob der auf dem Online-Ticket
        angegebene Name mit dem Namen auf dem Ausweisdokument übereinstimmt.
        Alle weiteren Daten können von Ihnen abgedeckt werden. Wenn die Namen
        übereinstimmen, wird das Online-Ticket zur Umpersonalisierung
        freigegeben. Eine Nutzung Ihrer Daten zu anderen Zwecken als der
        Prüfung, ob die Person, die das Ticket umpersonalisieren lassen möchte,
        tatsächlich mit dem Ticketkäufer identisch ist, erfolgt nicht. Wir
        werden die von Ihnen hochgeladenen Daten unverzüglich wieder löschen,
        wenn die Umpersonalisierung abgeschlossen ist.
      </p>
      <p>
        9.4. Zusätzlich müssen Sie den Vor- und Nachnamen und die E-Mail-Adresse
        der Person, der Sie das Ticket übertragen möchten, angeben. Ist die
        Umpersonalisierung des Tickets erfolgt, wird dem Erwerber per E-Mail ein
        auf seinen Namen ausgestelltes Online-Ticket übersandt. Der Versand
        dieses neuen Online-Tickets erfolgt per E-Mail an die von Ihnen
        angegebene Adresse. Gleichzeitig mit Versand des neuen Online-Tickets an
        den Erwerber wird Ihr Online-Ticket gesperrt. Ihr Online-Ticket
        berechtigt nach Übertragung nicht mehr zum Einlass.
      </p>
      <p>
        9.5. Für die Umpersonalisierung berechnet N3 Ihnen eine
        Bearbeitungsgebühr von EUR 5,00. Sollte die Veranstaltung nach der
        Umpersonalisierung ausfallen und/oder verlegt werden, sind wir für den
        Fall des Rücktritts vom Vertrag mit dem Veranstalter nicht zur
        Rückerstattung der von Ihnen bereits gezahlten Bearbeitungsgebühr
        verpflichtet, da wir unsere Leistung bereits erbracht haben.
      </p>
      <p>
        9.6. Die Umpersonalisierung kann nur bis spätestens 7 (sieben) Tagen vor
        Einlassbeginn zur gebuchten Veranstaltung erfolgen.
      </p>
      <p><strong>10. HAFTUNG / GEWÄHRLEISTUNG</strong></p>
      <p>
        10.1. Die Informationen über die Veranstaltung, die Ihnen angezeigt
        werden, wurden vom Veranstalter mitgeteilt. Wir haften daher nicht für
        die Richtigkeit dieser Informationen. Dies gilt nicht, wenn wir von der
        Unrichtigkeit einer solchen Information Kenntnis erlangen (z.B. durch
        eine Kundenbeschwerde) und nicht darauf hinwirken, dass der Veranstalter
        die Information richtigstellt.
      </p>
      <p>
        10.2. Wir schließen unsere Haftung für leicht fahrlässige
        Pflichtverletzungen aus, sofern nicht Schäden aus der Verletzung des
        Lebens, des Körpers oder der Gesundheit oder Garantien betroffen oder
        Ansprüche nach dem Produkthaftungsgesetz berührt sind. Unberührt bleibt
        ferner die Haftung für die Verletzung von Pflichten, deren Erfüllung die
        ordnungsgemäße Durchführung des Vertrages überhaupt erst ermöglicht und
        auf deren Einhaltung Sie als Kunde regelmäßig vertrauen dürfen. Gleiches
        gilt für Pflichtverletzungen unserer Erfüllungsgehilfen.
      </p>
      <p><strong>11. ANWENDBARES RECHT / GERICHTSSTAND</strong></p>
      <p>
        11.1. Soweit es sich beim Kunden nicht um einen Verbraucher handelt, ist
        ausschließlich deutsches Recht unter Ausschluss des UN Kaufrechts
        anwendbar.
      </p>
      <p>
        11.2. Erfüllungsort und Gerichtsstand ist Nürnberg, soweit es sich bei
        dem Kunden um einen Kaufmann, eine juristische Person des öffentlichen
        Rechts oder öffentlich-rechtliches Sondervermögen handelt.
      </p>
      <p><strong>12. SCHLUSSBESTIMMUNGEN</strong></p>
      <p>
        12.1. N3 hat bis zum Zeitpunkt des Vertragsschlusses neben diesen AGB
        keine Vereinbarungen getroffen oder Zusagen gemacht, weder mündlich noch
        schriftlich.
      </p>
      <p>
        12.2. Sollten einzelne Klauseln dieser AGB ganz oder teilweise unwirksam
        oder nichtig sein, berührt dies die Wirksamkeit der anderen Klauseln
        nicht.
      </p>
      <p><strong>13. ANFRAGEN / KONTAKT</strong></p>
      <p>
        Anfragen, die sich auf Bestellungen von Online-Tickets über N3 beziehen,
        richten Sie bitte an: support@n3.app
      </p>
      <p>
        <strong>Online-Streitbeilegung gemäß Art. 14 Abs. 1 ODR-VO: </strong>
      </p>
      <p>
        Die Europäische Kommission stellt eine Plattform zur
        Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr.
        Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht
        bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>
    </div>
  </div>
</template>
<script>
import { onMounted } from "vue";
import { scrollToTop } from "@/utils/helper";
import { useMeta } from "vue-meta";
export default {
  setup() {
    useMeta({
      title: "Terms and Conditions",
    });
    onMounted(() => {
      scrollToTop();
    });
  },
};
</script>
